/* ============================================================
   KKUMI — Sleeve Sizing Helper ("Not sure what fits?")
   State: selected sleeve tile, selected card type, category filter.
   Everything visible is server-rendered from block settings and
   read back from data-* attributes; copy labels come from the
   section root's data-* (merchant settings). Fit maths: KKSleeveFit.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var Fit = window.KKSleeveFit;
    var tiles = [].slice.call(root.querySelectorAll('[data-ssh-tile]'));
    var slots = [].slice.call(root.querySelectorAll('[data-ssh-slot]'));
    var chips = [].slice.call(root.querySelectorAll('[data-ssh-cat]'));
    var sel = root.querySelector('[data-ssh-card]');
    if (!Fit || !tiles.length) return;

    var L = root.dataset;
    var O = Fit.optsFrom(L);
    var cards = sel ? [].slice.call(sel.options).map(function (o) {
      o.textContent = o.dataset.name + ' · ' + Fit.fmt(L.fmtSize, o.dataset.w, o.dataset.h);
      return { name: o.dataset.name, w: +o.dataset.w, h: +o.dataset.h };
    }) : [];
    if (!cards.length) return;
    var pool = tiles.map(function (t) {
      return { name: t.dataset.name, layer: t.dataset.layer, w: +t.dataset.w, h: +t.dataset.h };
    });

    var $ = function (s) { return root.querySelector(s); };
    var el = {
      role: $('[data-ssh-role]'), name: $('[data-ssh-name]'), verdict: $('[data-ssh-verdict]'),
      desc: $('[data-ssh-desc]'), pair: $('[data-ssh-pair]'), note: $('[data-ssh-note]'),
      dSleeve: $('[data-ssh-d-sleeve]'), dInner: $('[data-ssh-d-inner]'), dW: $('[data-ssh-d-w]'), dH: $('[data-ssh-d-h]'), dCard: $('[data-ssh-d-card]'),
      dim: $('[data-ssh-dim]'), inner: $('[data-ssh-inner]'),
      cardNm: $('[data-ssh-card-nm]'), cardDim: $('[data-ssh-card-dim]'),
      shop: $('[data-ssh-shop]'), fitLbl: $('[data-ssh-fit-lbl]'), spare: $('[data-ssh-spare]')
    };
    var panel = $('[data-ssh-panel]'), empty = $('[data-ssh-empty]');
    var STATES = ['perfect', 'double', 'loose', 'big', 'small'];

    // Draw the diagram to scale: 1.45px/mm, shrunk so the biggest sleeve fits the 110x150 box.
    var maxW = 0, maxH = 0;
    pool.forEach(function (s) { maxW = Math.max(maxW, s.w); maxH = Math.max(maxH, s.h); });
    cards.forEach(function (c) { maxW = Math.max(maxW, c.w); maxH = Math.max(maxH, c.h); });
    var PX = Math.min(1.9, 122 / maxW, 168 / maxH);

    var cur = 0, curCard = 0, filter = 'all';

    function setState(node, state) {
      STATES.forEach(function (s) { node.classList.remove('is-' + s); });
      node.classList.add('is-' + state);
    }

    function draw() {
      var c = cards[curCard];
      var results = pool.map(function (s) { return Fit.evaluate(s, c, O, pool); });
      var usable = function (i) { return Fit.works(results[i].state); };
      var inFilter = function (i) { return filter === 'all' || tiles[i].dataset.cat === filter; };

      // "Too big" / "too small" sleeves are disabled; keep the selection on one that works.
      var any = results.some(function (x) { return Fit.works(x.state); });
      if (any) {
        if (!tiles.some(function (_, i) { return usable(i) && inFilter(i); })) filter = 'all';
        if (!(usable(cur) && inFilter(cur))) {
          for (var i = 0; i < tiles.length; i++) { if (usable(i) && inFilter(i)) { cur = i; break; } }
        }
      }
      var t = tiles[cur], d = pool[cur], r = results[cur];

      // No sleeve suits this card at all: swap the panel for the request state.
      panel.hidden = !any;
      empty.hidden = any;
      if (!any) Fit.fillEmpty(root, c, $('[data-ssh-empty-cta]'), sel.options[curCard].dataset.emptyBody);

      chips.forEach(function (b) {
        var cat = b.dataset.sshCat;
        var has = tiles.some(function (x, i) { return usable(i) && (cat === 'all' || x.dataset.cat === cat); });
        b.disabled = !has;
        b.setAttribute('aria-pressed', String(cat === filter));
      });
      tiles.forEach(function (b, i) {
        b.hidden = !inFilter(i);
        b.disabled = !usable(i);
        b.setAttribute('aria-disabled', String(!usable(i)));
        b.setAttribute('aria-pressed', String(i === cur && any));
        setState(b, results[i].state);
        b.querySelector('[data-ssh-tile-dim]').textContent = Fit.fmt(L.fmtSize, pool[i].w, pool[i].h);
        b.querySelector('[data-ssh-tile-v]').textContent = Fit.label(L, results[i].state);
      });
      slots.forEach(function (s, i) { s.hidden = i !== cur; });

      Fit.popName(el.name, t.dataset.name, 'kk-ssh__name-pop');
      el.verdict.textContent = Fit.label(L, r.state);
      el.verdict.className = 'kk-sv__verdict kk-sv__verdict--' + r.state;
      el.role.textContent = t.dataset.role;
      el.desc.textContent = t.dataset.desc;
      el.pair.textContent = t.dataset.pair;
      if (el.shop) {
        var href = t.dataset.shop;
        el.shop.hidden = !href;
        el.shop.querySelector('[data-ssh-shop-lbl]').textContent = (el.shop.dataset.tpl || 'Shop {name}').replace('{name}', t.dataset.name);
        if (href) el.shop.setAttribute('href', href); else el.shop.removeAttribute('href');
      }
      el.note.textContent = Fit.noteFor(L, r, O);

      el.dim.textContent = Fit.fmt(L.fmtSize, d.w, d.h);
      el.inner.textContent = Fit.fmt(L.fmtSize, r.iw, r.ih);
      el.cardNm.textContent = c.name;
      el.cardDim.textContent = Fit.fmt(L.fmtSize, c.w, c.h);
      if (r.state === 'small') {
        var sf = Fit.shortfall(r, O);
        el.fitLbl.textContent = L.over;
        el.spare.textContent = Fit.fmt(L.fmtShort, sf.w, sf.h);
      } else {
        el.fitLbl.textContent = L.room;
        el.spare.textContent = Fit.fmt(L.fmtSpare, r.sw, r.sh);
      }

      var px = function (mm) { return mm * PX + 'px'; };
      el.dSleeve.style.width = px(d.w);
      el.dSleeve.style.height = px(d.h);
      el.dInner.style.width = px(r.iw);
      el.dInner.style.height = px(r.ih);
      el.dInner.style.bottom = px(O.wall / 2);
      el.dCard.style.width = px(c.w);
      el.dCard.style.height = px(c.h);
      el.dCard.style.bottom = px((d.h - c.h) / 2);
      var line = function (n) { return (L.fmtLine || '{n}mm').replace('{n}', n); };
      el.dW.textContent = line(d.w);
      el.dH.textContent = line(d.h);
      el.dCard.classList.toggle('is-over', r.sw < 0 || r.sh < 0);
    }

    tiles.forEach(function (b, i) { b.addEventListener('click', function () { cur = i; draw(); }); });
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.dataset.sshCat;
        draw();
      });
    });
    sel.addEventListener('change', function () { curCard = +sel.selectedIndex; draw(); });
    draw();
  }

  function boot() { document.querySelectorAll('[data-kk-ssh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
